import {
    SET_ADMIN_FINANCE_FEES_LIST,
    DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE,
    DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE
} from './constants';

export const initialState = { 
    feesList: null,
    showDefaultTechFeeModal: false
};

const reducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case SET_ADMIN_FINANCE_FEES_LIST:
          return {
            ...state,
            feesList: payload
          }; 
        case DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE:
          return {
            ...state,
            showDefaultTechFeeModal: payload || initialState.showDefaultTechFeeModal
          };
          case DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE:
            return {
              ...state,
              showTournamentTechFeeModal: payload || initialState.showTournamentTechFeeModal
            };
        default:
            return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/features/finance/fees/reducer.js